export const deliveryCategoryLabels: Record<string, string> = {
  TKK: 'Tiefkühl',
  TAB: 'Tabak',
  TRO: 'Trocken',
  FRI: 'Frische',
};
